import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432ef4d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "myModal",
  class: "modalmsg"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header bg-danger" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-light" }, "Error")
], -1))
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "modal-footer bg-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.messageLines(_ctx.message).length == 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true),
        (_ctx.messageLines(_ctx.message).length > 1)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageLines(_ctx.message), (line) => {
                return (_openBlock(), _createElementBlock("li", { key: line }, _toDisplayString(line), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-secondary",
          id: "error-ok",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "OK")
      ])
    ])
  ]))
}